import TournamentList from "../../components/tournament/TournamentList";
import TournamentShow from "../../components/tournament/TournamentShow";
import TournamentRules from "../../components/tournament/TournamentRules";
import authenticated from "../middleware/authenticated";
import connectToWebsocket from "../middleware/connectToWebsocket";
import TournamentGroupGame from "../../components/games/TournamentGroupGame/TournamentGroupGame";

export default [
    {
        path: '/tournaments',
        component: TournamentList,
        name: 'tournaments-list',
        meta: {
            hasNavigation: true,
        }
    },

    {
        path: '/tournament/:id',
        component: TournamentShow,
        name: 'tournaments-show',
        props: route => {
            return {
                tournamentId: route.params.id
            }
        },
        meta: {
            hasNavigation: true,
        }
    },

    {
        path: '/tournament/:id/rules',
        component: TournamentRules,
        name: 'tournaments-rules',
        props: route => {
            return {
                tournamentId: route.params.id
            }
        },
        meta: {
            hasNavigation: true,
        }
    },

    {
        path: '/game/tournament/:id',
        component: TournamentGroupGame,
        name: 'findTournamentGame',
        props: route => {
            return {
                id: route.params.id
            }
        },
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },
]